import { useState, useEffect } from "react";
import { Tag, X, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";

export const PROMO_STORAGE_KEY = "sa_promo_code";

export const PromoCodeField = ({ amount = 0, onChange, testIdPrefix = "promo" }) => {
  const [code, setCode] = useState(() => localStorage.getItem(PROMO_STORAGE_KEY) || "");
  const [applied, setApplied] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const apply = async (value = code) => {
    if (!value.trim()) return;
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/api/promo/validate", { code: value, amount });
      setApplied(data); onChange?.(data);
      localStorage.setItem(PROMO_STORAGE_KEY, data.code);
    } catch (err) {
      setApplied(null); onChange?.(null);
      setError(err.response?.data?.detail || "Invalid code");
    } finally { setLoading(false); }
  };

  useEffect(() => { if (code) apply(code); }, [amount]); // eslint-disable-line react-hooks/exhaustive-deps

  const clear = () => { setApplied(null); setCode(""); setError(""); onChange?.(null); localStorage.removeItem(PROMO_STORAGE_KEY); };

  if (applied) {
    const label = applied.discount_type === "percent" ? `${applied.discount_value}% off` : `$${applied.discount_value} off`;
    return (
      <div className="flex items-center justify-between gap-3 bg-green-50 border border-green-200 rounded-lg px-4 py-2.5" data-testid={`${testIdPrefix}-applied`}>
        <div className="flex items-center gap-2 text-sm text-green-800"><Tag className="w-4 h-4" /><span className="font-bold">{applied.code}</span><span>· {label}</span></div>
        <button type="button" onClick={clear} className="text-green-700 hover:text-green-900" data-testid={`${testIdPrefix}-remove-btn`}><X className="w-4 h-4" /></button>
      </div>
    );
  }
  return (
    <div>
      <div className="flex gap-2">
        <Input className="bg-white border-slate-300 uppercase" placeholder="Promo code" value={code} onChange={e => setCode(e.target.value.toUpperCase())} data-testid={`${testIdPrefix}-input`} />
        <button type="button" onClick={() => apply()} disabled={loading || !code.trim()} className="bg-slate-900 hover:bg-slate-700 text-white text-sm font-medium px-4 rounded-lg disabled:opacity-50 flex items-center gap-1.5" data-testid={`${testIdPrefix}-apply-btn`}>
          {loading && <Loader2 className="w-3.5 h-3.5 animate-spin" />}Apply
        </button>
      </div>
      {error && <p className="text-xs text-red-600 mt-1.5" data-testid={`${testIdPrefix}-error`}>{error}</p>}
    </div>
  );
};
